
class goods {
  constructor(location) {
    this.goodsList = location
  }
  getLocation
}

const state = {
  locationInfo: ''
}

const mutations = {
  SET_LOCATION(state, info) {
    state.locationInfo = info
  }
}

const actions = {
  async getGoods () {
  
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}